import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/AppIcon.svg")